import { supabase } from '../supabase'
import type { RoomGame } from '../navigationBus'

export interface ActiveRoom {
  game: RoomGame
  room_id: string
  code: string
  status: string
  mode: string | null
  my_turn: boolean
  turn_deadline_at: string | null
  players: number
  created_at: string
}

/**
 * Every still-running room the signed-in user is seated in, my-turn
 * rooms first, then soonest deadline. Guests get an empty list (the
 * RPC is authenticated-only and self-scoped).
 */
export async function fetchMyActiveRooms(): Promise<ActiveRoom[]> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase as any).rpc('list_my_active_rooms')
  if (error) throw error
  return Array.isArray(data) ? (data as ActiveRoom[]) : []
}
